import baseObject from '#frontend/dtm/shared/base.js';

/**
 * Company details page object
 * @param {object} cart Cart object
 * @returns {object} Created Cart Page object
 */
export default (cart) => ({
	page_name: 'company details',
	...baseObject(cart)
});
